import React from 'react';
import logo from '../images/loansense.svg';
import linkedIn from '../images/linkedin.png';
import styles from './footer.module.css';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={`${styles.footer__column} ${styles.column_4}`}>
          <a href="/" className={styles.footer__logo}>
            <img src={logo} alt="" />
          </a>
        </div>
        <div
          className={[
            styles.footer__column,
            styles.column_4,
            styles.buttons
          ].join(' ')}
        >
          <a
            href="https://www.myloansense.com/savings"
            className={[styles.btn, styles.btn_long].join(' ')}
          >
            RETENTION SAVINGS CALCULATOR
          </a>
          <a
            href="https://www.myloansense.com/request-demo"
            className={[styles.footer__btn, styles.btn].join(' ')}
          >
            REQUEST DEMO
          </a>
        </div>

        <div className={[styles.footer__column, styles.column_4].join(' ')}>
          <ul className={styles.footer__list}>
            <li className={styles.footer__list_item}>
              <a
                href="https://www.myloansense.com"
                className={styles.footer__list_link}
              >
                Home
              </a>
            </li>

            <li className={styles.footer__list_item}>
              <a
                href="https://www.myloansense.com/brokers"
                className={styles.footer__list_link}
              >
                Brokers
              </a>
            </li>
            {/* <li className={styles.footer__list_item}>
              <a
                href="https://www.myloansense.com/about"
                className={styles.footer__list_link}
              >
                About Us
              </a>
            </li> */}
            <li className={styles.footer__list_item}>
              <a
                href="https://www.myloansense.com/request-demo"
                className={styles.footer__list_link}
              >
                Request Demo
              </a>
            </li>
            <li className={styles.footer__list_item}>
              <a
                href="https://blog.myloansense.com"
                className={styles.footer__list_link}
              >
                Blog
              </a>
            </li>
          </ul>
        </div>
        <div className={[styles.footer__column, styles.column_4].join(' ')}>
          <ul className={styles.footer__list}>
            <li className={styles.footer__list_item}>
              <a
                href="https://www.savethatdough.com/privacy"
                className={styles.footer__list_link}
              >
                Privacy policy
              </a>
            </li>
            <li className={styles.footer__list_item}>
              <a
                href="https://www.savethatdough.com/terms/"
                className={styles.footer__list_link}
              >
                Terms of use
              </a>
            </li>
          </ul>
        </div>
        <div className={[styles.footer__column, styles.column_4].join(' ')}>
          <ul className={styles.footer__list}>
            <li className={styles.footer__list_item}>
              <a
                href="https://www.linkedin.com/company/savethatdough/"
                className={styles.footer__list_link}
              >
                <img src={linkedIn} alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={[styles.footer__row, styles.row].join(' ')}>
        <p className={styles.footer__copyright}> © 2020 SavethatDough LLC.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
